import { Input } from '@pancakeswap/uikit'
import styled from 'styled-components'

const Box = styled.div`
  width: 100%;
  border-radius: 4px;
  position: relative;
`

const BottomLeft = styled.img`
  position: absolute;
  bottom: 0px;
  left: 0px;
`

const BottomRight = styled.img`
  position: absolute;
  bottom: 0px;
  right: 0px;
`

const EInput = styled(Input)`
  background-color: ${({ theme }) => theme.colors.input};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  border-radius: 16px;
  color: ${({ theme }) => theme.colors.text};
  display: block;
  font-size: 16px;
  outline: 0;
  padding: 0 16px;
  width: 100%;
  transition: border-color 200ms ease, box-shadow 200ms ease;

  &:hover:not(:disabled) {
    border-color: rgba(139, 92, 246, 0.28);
  }

  /* Global.tsx suppresses the UA outline on inputs, so without this ring the
     field would have no visible focus state at all. */
  &:focus {
    border-color: rgba(139, 92, 246, 0.55);
    box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.16);
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.textSubtle};
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.backgroundDisabled};
    box-shadow: none;
    color: ${({ theme }) => theme.colors.textDisabled};
    cursor: not-allowed;
  }
`

const ESearchBox = (props: any) => {
  return (
    <Box
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <EInput placeholder="Search" {...props} />
    </Box>
  )
}

export default ESearchBox
